import { AbstractControl, Validators, ValidatorFn } from "@angular/forms";

import { isPresent } from '../../helpers/function';

export const digits: ValidatorFn = (
  control: AbstractControl
): { [key: string]: boolean } => {
  if (isPresent(Validators.required(control))) return null;

  const v: string = control.value;
  return /^\d+$/.test(v) ? null : { digits: true };
};
